import React from "react";
import Logo from "assets/images/system-crash/logo.png";
import Char from "assets/images/system-crash/char.png";
import styled from "styled-components";
import { Button } from "antd";
import IntlMessages from "components/Message/IntlMessages";
import { replace } from "connected-react-router";
import { Routes } from "const";
import { useDispatch } from "react-redux";
import Portal from "components/Portal";
import classNames from "classnames";
import useFallcackCalc from "components/hooks/useFallcackCalc";

const fullScreenStyle = {
  position: "absolute",
  top: 0,
  zIndex: "100000",
  background: "white",
  height: "100vh",
};

function SystemIsNotReady({ fullScreen, showBack, onClose, ...props }) {
  const dispatch = useDispatch();

  useFallcackCalc(".float-close-btn", "--top-float-close-btn", 100, { adjust: 30 });

  const component = (
    <SystemIsNotReadyStyled className="bg-page-config h-100" {...props}>
      <div className="container h-100">
        <div className="d-flex align-items-center justify-content-center h-100">
          <div className={classNames({ "py-5": fullScreen })}>
            <img src={Logo} className="img-fluid mx-auto d-block" alt="krungthai logo" />
            <div className="config-border"></div>
            <div className="page-config-content">
              <div className="text-th-1 c-title">
                <IntlMessages id="global.system-not-ready" />
              </div>
              <div className="text-th-2">
                <div className="c-desc">
                  <IntlMessages id="global.system-not-ready.come-back-later-1" />
                </div>
                <div className="c-desc">
                  <IntlMessages id="global.system-not-ready.come-back-later-2" />
                </div>
              </div>
              {/* <div className="text-th-2">
              </div> */}
            </div>
            <div className="text-center my-4">
              {showBack && (
                <Button className="btn button-ktb-main px-4" onClick={() => dispatch(replace(Routes.SignIn))}>
                  <IntlMessages id="global.goback.to.main" />
                </Button>
              )}
            </div>
            <div className="img-ch">
              <img src={Char} alt="krungthai character" />
            </div>
            {onClose && (
              <Button className="btn button-ktb-line float-close-btn px-4 mt-5" onClick={onClose}>
                <IntlMessages id="global.close" />
              </Button>
            )}
          </div>
        </div>
      </div>
    </SystemIsNotReadyStyled>
  );

  if (fullScreen) {
    return (
      <Portal portalClass="system-not-ready" styles={fullScreenStyle}>
        {component}
      </Portal>
    );
  }

  return component;
}

export default SystemIsNotReady;

SystemIsNotReady.defaultProps = {
  fullScreen: true,
  showBack: true,
  showClose: false,
};

const SystemIsNotReadyStyled = styled.section`
  .bg-page-config {
    background: url(assets/images/system-crash/bg.jpg) no-repeat top #ffffff;
  }

  .bg-page-config:after {
    content: "";
    position: fixed;
    width: 100%;
    height: 30%;
    bottom: 0;
    background-image: linear-gradient(to top, #ffffff 20%, rgba(255, 255, 255, 0));
    z-index: 1;
  }

  .c-title {
    font-size: clamp(24px, 8.4dvw, 36px) !important;
    white-space: nowrap;
  }

  .c-desc {
    font-size: clamp(21px, 6.6dvw, 29px) !important;
    white-space: nowrap;
  }

  .page-config-content-main {
    padding: 120px 0px;
    text-align: center;
  }

  .page-config-content {
    text-align: center;
    color: #091d39;
  }

  .page-config-content .text-th-1 {
    font-weight: bold;
    /* font-size: 36px; */
  }

  .page-config-content .text-th-2 {
    /* font-size: 28px; */
    line-height: 1.2;
    margin-top: 20px;
  }

  .config-border {
    border: 4px solid #fcb813;
    width: 160px;
    margin: 30px auto;
  }

  .img-ch {
    text-align: center;
  }

  .img-ch img {
    width: 400px;
  }

  .float-close-btn {
    position: absolute;
    left: 50%;
    top: var(--top-float-close-btn);
    top: calc(var(--app-height) + 30px);
    top: calc(100vh + 30px);
    top: calc(100dvh + 30px);
    transform: translateX(-50%);
    color: white;
    border-color: white;
  }

  @media (min-width: 992px) and (max-width: 1199px) {
  }

  @media (min-width: 768px) and (max-width: 991px) {
    .page-config-diplay-none {
      display: none;
    }
  }

  @media (max-width: 767px) {
    .page-config-diplay-none {
      display: none;
    }
    .page-config-content-main {
      padding: 143px 0px;
    }
    /* .page-config-content .text-th-1 {
      font-size: 33px;
    }

    .page-config-content .text-th-2 {
      font-size: 29px;
      margin-top: 10px;
    } */
  }

  @media (max-width: 480px) {
    .page-config-diplay-none {
      display: none;
    }
    .page-config-content-main {
      padding: 143px 0px;
    }
    /* .page-config-content .text-th-1 {
      font-size: 30px;
    }

    .page-config-content .text-th-2 {
      font-size: 26px;
      margin-top: 10px;
    } */

    .img-ch img {
      width: 100%;
    }
  }
`;
